export default {

	/*
		==========================================
		Header
		==========================================
	*/
	"see my projects" 		: "voir mes projets",
	"disconnection" 		: "déconnexion",

	/*
		==========================================
		Projects
		==========================================
	*/

	// Project list
	"started projects"		: "mes projets en cours",
	"closed projects"		: "mes projets terminés",
	"create new project"	: "créer un projet",

	// Project details
	"city:"					: "ville :",
	"date of receipt:"		: "date de réception :",
	"protected mks:"		: "organigramme protégé :",
	"just a2p:"				: "uniquement A2P :",
	"finition:"				: "finition :",
	"email:"				: "email :",
	"comment:"				: "commentaire :",
	"delete project"		: "supprimer ce projet",
	"open project"			: "ouvrir ce projet",

	// Project form
	"new project"				: "nouveau projet",
	"edit project"				: "edition de projet",
	"project name"				: "nom du projet",
	"city"						: "ville",
	"desired date of receipt"	: "date de réception souhaitée",
	"type of project"			: "type de projet",
	"email"						: "email",
	"comment"					: "commentaire",
	"finition"					: "finition",
	"polished brass"			: "laiton poli",
	"nickel-plated brass"		: "laiton nickelé",
	"advanced options"			: "options avancées",
	"protected mks"				: "organigramme protégé",
	"just a2p"					: "seulement A2P",
	"create project"			: "créer le projet",
	"save project"				: "enregistrer les modifications",

	/*
		==========================================
		Clone project template
		==========================================
	*/
	"Choose from our selection buildings or create new building"
		: "Choisir parmi notre sélection de bâtiments ou créer un nouveau bâtiment",
	"multipurpose room"			: "salle polyvalente",
	"ehpad"						: "ehpad",
	"school group"				: "groupe scolaire",
	"compagny"					: "entreprise",
	"new building"				: "nouveau bâtiment",
	"city hall"					: "mairie",
	"nursery"					: "crèche",
	"residence"					: "residence",
	"9 buildings have been preconfigured for you."
		: "9 bâtiments ont été préconfigurés spécialement pour vous. ",
	"Simply click on the one you want to edit."
		: "Il vous suffit de cliquer sur celui de votre choix pour l'éditer.",
	"Can't find your happiness?"
		: "Vous ne trouvez pas votre bonheur ? ",
	"You just need to create one by clicking the button at the bottom right of this screen."
		: "Il vous suffit d'en créer un en cliquant sur le bouton <Nouveau bâtiment>.",

	/*
		==========================================
		Matrix
		==========================================
	*/

	// Locking list
	"add group"					: "ajouter un groupe",
	"add locking"				: "ajouter une ouverture",

	// Locking form
	"quantity"					: "nombre de cylindres",
	"servant keys number?"		: "nombre de clés par cylindre ?",
	"type of cylinder?"			: "type de cylindre ?",
	"demi-cylinder"				: "demi-cylindre",
	"cylinder 2 entries"		: "cylindre 2 entrées",
	"button cylinder"			: "cylindre à bouton",
	"disengageable"				: "débrayable",
	"dimensions?"				: "dimensions ?",
	"ext."						: "ext.",
	"int."						: "int.",
	"marking?"					: "marquage ?",

	// Group from
	"what group you want to add?"	: "quel groupe souhaitez-vous ajouter ?",

	// Role list
	"add key"					: "ajouter une clé",

	// Role form
	"name"						: "nom",
	"example: mayor"			: "Ex : maire",
	"number of keys"			: "nombre de clés",
	"marking of key? (optional)": "marquage de clé ? (optionnel)",
	"ex: PP6931"				: "Ex : PP6931",
	"actions"					: "actions",

	// Offer card
	"brand"			: "Marque",
	"description"	: "Description",
	"delay"			: "Délai",
	"days"			: "jours",
	"safety index"	: "Indice de sécurité",
	"EN1303 norme"	: "Norme EN1303",
	"protection"	: "Protection des clés",
	"choose"		: "choisir",

	/*
		==========================================
		General
		==========================================
	*/
	"yes"		: "oui",
	"no"		: "non",

	// Buttons
	"help"		: "aide",
	"add"		: "ajouter",
	"delete"	: "supprimer",
	"duplicate"	: "dupliquer",
	"save"		: "enregistrer",
	"cancel"	: "annuler",

	/*

	"open project" 			: "ouvrir projet",
	"help" 					: "aide",

	"see my projects"				: "voir mes projets",
	// Lockings panel
	"lockings"						: "ouvertures",
	"add group"						: "ajouter un groupe",
	"add locking"					: "ajouter une ouverture",
	// Group form
	"enter group name"				: "entrez le nom du groupe",
	"add"							: "ajouter",
	"cancel"						: "annuler",
	// Locking form
	"delete"						: "supprimer",
	"duplicate"						: "dupliquer",
	"name"							: "nom",
	"number of cylinder?"			: "nombre de cylindre ?",
	"type of cylinder?"				: "type de cylindre ?",
	"demi-cylinder"					: "demi-cylindre",
	"cylinder 2 entries"			: "cylindre 2 entrées",
	"button cylinder"				: "cylindre a bouton",
	"switchable"					: "débrayable",
	"switchable tooltip"			: "débrayable info",
	"dimensions?"					: "dimensions ?",
	"dimensions tooltip"			: "dimensions info",
	"mark of cylinder? (option)"	: "marquage de cylindre (option)",
	"mark of cylinder tooltip"		: "marquage de cylindre info",
	"validate"						: "valider"
	*/
}



// WEBPACK FOOTER //
// ./src/js/common/translation/fr-FR.js